import { AnimatePresence, type HTMLMotionProps, motion } from "framer-motion";
import * as React from "react";

import { cn } from "@/shadcn/lib/utils";

export type CollapsibleProps = Omit<HTMLMotionProps<"div">, "children"> & {
  readonly isOpen: boolean;
  readonly duration?: number;
  readonly children: React.ReactNode;
};

export const Collapsible = React.forwardRef<HTMLDivElement, CollapsibleProps>(
  ({ isOpen, duration = 0.3, children, className, ...props }, ref) => (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          animate={{ height: "auto", opacity: 1 }}
          className={cn("overflow-hidden", className)}
          exit={{ height: 0, opacity: 0 }}
          initial={{ height: 0, opacity: 0 }}
          ref={ref}
          transition={{ duration, ease: "easeInOut" }}
          {...props}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  ),
);

Collapsible.displayName = "Collapsible";
